import apivendas from '@/services/api-recebimentoweb'; // Mantive o nome do seu serviço de API

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  actions: {

    async find(_, { where, ...params } = {}) {
      const { data } = await apivendas.get('condicional', { params: { ...where, ...params } });
      return data;
    },

    async produtosEmCondicional(_, { where }) {
      const { data } = await apivendas.get('condicional/produtosvendidos', { params: where });
      return data;
    },
    async detalharAbertos(context, { where }) {
      const { data } = await apivendas.get('condicional/detalhar-abertos', { params: { where } });
      return data;
    },
    async detalhar(context, { id }) {
      const { data } = await apivendas.get(`condicional/detalhar/${id}`);
      return data;
    },
    async detalheVendedor(_, { where }) {
      const { data } = await apivendas.get('condicional/detalharvendedor', { params: where });
      return data;
    },
    async relatorioPorVendedor(_, { where }) {
      const { data } = await apivendas.get('condicional/relatorio/por-vendedor', { params: where });
      return data;
    },

    async findById(_, { id }) {
      const { data } = await apivendas.get(`condicional/${id}`);
      return data;
    },

    async create(_, payload) {
      const { data } = await apivendas.post('condicional', payload);
      return data;
    },

    async update(_, { id, ...payload }) {
      const { data } = await apivendas.put(`condicional/${id}`, payload);
      return data;
    },

    async delete(_, { id }) {
      const { data } = await apivendas.delete(`condicional/${id}`);
      return data;
    },
  },

  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
